import axios from "config/axios/base";
import qs from "qs";

export const getCases = ({ query = {}, options = null }) => axios.get(`/cases?${qs.stringify(query)}`, options);
export const patchCase = ({ body = {}, options = null }) => axios.patch("/cases/update", body, options);
export const getSingleCase = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/cases/${params?.id}?${qs.stringify(query)}`, options);
export const storeAdminCase = ({ body = {}, options = null }) => axios.post("/cases/admin_store", body, options);
export const patchAdminCase = ({ params = {}, body = {}, options = null }) =>
	axios.patch(`/cases/admin_update/${params?.id}`, body, options);
export const deleteAdminCase = ({ params = {}, options = null }) =>
	axios.delete(`/cases/admin_destroy/${params?.id}`, options);
export const getSingleAdminCase = ({ params = {}, options }) => axios.get(`/cases/show/${params?.id}`, options);
